import React, { Component } from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import './brandLogo.pcss'
import defaultLogo from '../../assets/ampparit-logo.svg'
import { refreshAllAds } from '../../ad/AlmaAd'

export default class BrandLogo extends Component {
  render() {
    const { frontPage } = this.props

    return (
      <div className='logo-wrapper'>
        <header className='brand-logo'>
          <Link to={ frontPage } onClick={ this.handleRefreshAdsIfOnSamePage } >
            <img src={ defaultLogo } alt='Ampparit.com - Etusivu' height='25' width='150' />
          </Link>
        </header>
      </div>
    )
  }

  shouldComponentUpdate(nextProps) {
    return this.props.frontPage !== nextProps.frontPage
  }

  handleRefreshAdsIfOnSamePage = () => {
    if (this.props.path === this.props.frontPage) {
      refreshAllAds()
    }
  }
}

BrandLogo.propTypes = exact({
  frontPage: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
})
